import axios from 'utils/axios';

export const getAllDeploymentGroups = async ({ perPage = 10, pageNo = 1, query = '', showDisabled = false }) => {
    try {
        const response = await axios.get('deployment-groups/', {
            params: { perPage, pageNo, showDisabled, query }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const createDeploymentGroup = async (data) => {
    try {
        const response = await axios.post('deployment-groups/', data);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const updateDeploymentGroup = async (data) => {
    try {
        const response = await axios.post('deployment-groups/update', data);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
export const getDeploymentGroupInfo = async (data) => {
    try {
        const response = await axios.get('deployment-groups/details', {
            params: { ...data }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const getDeploymentGroupUserInfo = async (data) => {
    try {
        const response = await axios.get('deployment-groups/user-info', {
            params: { ...data }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
